import { combineReducers } from 'redux';
import * as types from '../actions/types';

const addBlankOSGBoundsBySpecimenId = (state, specimens, property = '_id') => {
  specimens.reduce((acc, specimen) => {
    const key = specimen[property];

    if (!acc[key]) {
      acc[key] = {};
    }
    return acc;
  }, state);
};

const updateBounds = (state, payload) => {
  const { bounds, specimenId } = payload;
  const positionDetails = state[specimenId];
  return {
    ...state,
    [specimenId]: {
      ...positionDetails,
      bounds,
    },
  };
};

const updateRotationDegrees = (state, payload) => {
  const { degrees, specimenId } = payload;
  const positionDetails = state[specimenId];

  return {
    ...state,
    [specimenId]: {
      ...positionDetails,
      rotationDegrees: degrees,
    },
  };
};

const imagePositionDetailsBySpecimenId = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.GET_VALIDATION_SPECIMENS:
      return {
        ...state,
        ...addBlankOSGBoundsBySpecimenId(state, payload),
      };
    case types.GET_SPECIMENS_SUCCESS:
      return {
        ...state,
        ...addBlankOSGBoundsBySpecimenId(state, payload.specimens),
      };
    case types.SET_OSG_BOUNDS:
      return {
        ...state,
        ...updateBounds(state, payload),
      };
    case types.STORE_ROTATION_ANGLE_OF_SPECIMEN_IMAGE:
      return {
        ...state,
        ...updateRotationDegrees(state, payload),
      };
    default:
      return state;
  }
};

const OpenSeadragonReducer = combineReducers({
  imagePositionDetailsBySpecimenId,
});

export default OpenSeadragonReducer;

/* Selectors */
export const getBoundsForSpecimenImage = (state, specimenId) => {
  // console.log(state.imagePositionDetailsBySpecimenId[specimenId].bounds)

  // When a specimen(tab) is clicked immediately after img upload the
  // imagePositionDetailsBySpecimenId[specimenId] is undefined, which is fine
  // since there is no bounds/rotation data yet. But to avoid
  // "imagePositionDetailsBySpecimenId[specimenId].bound of undefined" crash
  // this TRY CATCH IS NEEDED.
  try {
    return state.imagePositionDetailsBySpecimenId[specimenId].bounds;
  } catch (e) {
    return null;
  }
};

export const getRotationForSpecimenImage = (state, specimenId) => {
  // See comment in getBoundsForSpecimenImage
  try {
    return state.imagePositionDetailsBySpecimenId[specimenId].rotationDegrees;
  } catch (e) {
    return null;
  }
};
